import React, { FC, useState } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import type { Comment } from './Stats.js';


type FiltersProps = {
  onFilterChange: (filter: string, value: string) => void;
  comments: Comment[];
};

const Filters: FC<FiltersProps> = ({ onFilterChange, comments }) => {
  const [dateFilterSwedish, setDateFilterSwedish] = useState('');
  const [authorFilter, setAuthorFilter] = useState('');
  const [streckFilter, setStreckFilter] = useState('');

  const uniqueStreck = comments
  .map((comment) => comment.streck)
  .filter((value, index, self) => self.indexOf(value) === index);

  const uniqueAuthors = comments
  .map((comment) => comment.position)
  .filter((value, index, self) => self.indexOf(value) === index);

  const handleDateFilterChange = (value: string) => {    
    switch (value) {
      case 'oldest-first':
        setDateFilterSwedish('Äldst först');
        break;
      case 'latest-first':
        setDateFilterSwedish('Senast först');
        break;
      case 'spring':
        setDateFilterSwedish('Vår (jan - juni)');
        break;  
      case 'fall':
        setDateFilterSwedish('Höst (juli - dec)');
        break;
      default:
        setDateFilterSwedish('');
        break;
    }

    onFilterChange('date', value);
  };

  const handleAuthorFilterChange = (value: string) => {
    setAuthorFilter(value);
    onFilterChange('author', value);
  };

  const handleStreckFilterChange = (value: string) => {
    setStreckFilter(value);
    onFilterChange('streck', value);
  };


  // TODO: Change date filter to "äldst först", "senast först", "vår", "höst "
  return (
    <div className="filter-container">
      <DropdownButton
        className="filter-dropdown"
        title={`Tid: ${dateFilterSwedish || 'Alla'}`}
        variant="secondary"
      >
        <Dropdown.Item onClick={() => handleDateFilterChange('')}>
          Alla
        </Dropdown.Item>
        <Dropdown.Item onClick={() => handleDateFilterChange('latest-first')}>
          Senast först
        </Dropdown.Item>
        <Dropdown.Item onClick={() => handleDateFilterChange('oldest-first')}>
          Äldst först
        </Dropdown.Item>
        <Dropdown.Item onClick={() => handleDateFilterChange('spring')}>
          Vår (jan - juni)
        </Dropdown.Item>
        <Dropdown.Item onClick={() => handleDateFilterChange('fall')}>
          Höst (juli - dec)
        </Dropdown.Item>
      </DropdownButton>
      <DropdownButton
        className="filter-dropdown"
        title={`Post: ${authorFilter || 'Alla'}`}
        variant="secondary"
      >
        <Dropdown.Item onClick={() => handleAuthorFilterChange('')}>
          Alla
        </Dropdown.Item>
        {uniqueAuthors.map((author) => (
          <Dropdown.Item
            key={author}
            onClick={() => handleAuthorFilterChange(author)}
          >
            {author}
          </Dropdown.Item>
        )
        )}
      </DropdownButton>
      <DropdownButton
        className="filter-dropdown"
        title={`Streck: ${streckFilter || 'Alla'}`}
        variant="secondary"
      >
        <Dropdown.Item onClick={() => handleStreckFilterChange('')}>
          Alla
        </Dropdown.Item>
        {uniqueStreck.map((streck) => (
          <Dropdown.Item
            key={streck}
            onClick={() => handleStreckFilterChange(streck)}
          >
            {streck}
          </Dropdown.Item>
        )
        )}
      </DropdownButton>
    </div>
  );
};

export default Filters;